import { IImage } from '@giphy/js-types'
import { bestfit } from '@giphy/js-util'
const getPosterUrl = (previews: IImage[], width: number, height: number) => {
    const { url } = bestfit(previews, width, height) as IImage
    // perhaps webp?
    return url
}

export default getPosterUrl
